import { render, staticRenderFns } from "./remove-picked-lpn.vue?vue&type=template&id=5222c0c6&"
import script from "./js/remove-picked-lpn.js?vue&type=script&lang=js&"
export * from "./js/remove-picked-lpn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports